/* Card swatch image swap (2026-07-17). Shipped as its own asset because the
   CDN object for quick-add.js was stuck serving a stale build for 13+ hours
   (theme API + GitHub both had the new file; /t/238 CDN path would not
   update). Self-contained on purpose: no dependency on quick-add.js.
   Color radios on collection cards carry their variant image via a
   server-rendered data-img attribute (see quick-add-colors.liquid). */
(function () {
  function srcsetFor(src) {
    return [165, 360, 535, 750, 1070, 1500]
      .map(function (w) { return src + '?width=' + w + ' ' + w + 'w'; })
      .join(',');
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'Color' || input.type !== 'radio') return;
    var form = input.closest('.quick-add-form');
    if (!form) return;
    var src = input.getAttribute('data-img');
    if (!src) return;
    var img = form.querySelector('.pdp-first__image img');
    if (!img) return;
    // The card image lives inside a <picture>: its <source> elements OVERRIDE
    // the img's src/srcset, so they must be rewritten too or nothing visibly
    // changes (img.src updates while currentSrc keeps rendering the old file).
    var picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (source) {
        source.srcset = srcsetFor(src);
      });
    }
    img.srcset = srcsetFor(src);
    img.src = src + '?width=535';
  });
})();
